export { default } from './Header';



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Header/index.ts